enum NavigationToEnum {
	ikeaMainPage = 'ikea web main page',
	ikeaFavorites = 'ikea web favorites',
	ikeaCart = 'ikea web shopping cart',
	ikeaAssembly = 'ikea assembly services info'
}
export default NavigationToEnum;
